import React from "react";
import {
  FilePdfOutlined,
  FileImageOutlined,
  FileUnknownOutlined,
} from "@ant-design/icons";

const FileAttachment = ({ url }) => {
  const decodedUrl = decodeURIComponent(url);
  const fileName = decodedUrl.split("/").pop().split("?")[0];
  const isImage = /\.(jpeg|jpg|gif|png|webp)$/i.test(fileName);
  const isPDF = /\.pdf$/i.test(fileName);

  return (
    <div style={{ display: "inline-block", marginRight: 8 }}>
      {isImage ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
          <img
            src={url}
            alt={fileName}
            style={{
              width: 64,
              height: 64,
              objectFit: "cover",
              borderRadius: 6,
              border: "1px solid #ccc",
            }}
          />
        </a>
      ) : (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "4px 6px",
            border: "1px solid #ddd",
            borderRadius: 6,
            textDecoration: "none",
            color: "#333",
            width: "fit-content",
            fontSize: 12,
          }}
        >
          {isPDF ? (
            <FilePdfOutlined style={{ fontSize: 20, color: "#d93025" }} />
          ) : (
            <FileUnknownOutlined style={{ fontSize: 20 }} />
          )}
          <span
            style={{
              maxWidth: 120,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {fileName}
          </span>
        </a>
      )}
    </div>
  );
};

export default FileAttachment;
